import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface CanExtendTrialState {
  value: boolean;
}

const canExtendTrial: Module<CanExtendTrialState, RootState> = {
  namespaced: true,
  state: {
    value: false,
  } as CanExtendTrialState,
  mutations: {
    setValue(state: CanExtendTrialState, data: CanExtendTrialState): void {
      state.value = data.value;
    },
  },
  getters: {
    canExtendTrial: (state: CanExtendTrialState) => state.value,
  },
};

export default canExtendTrial;
